import { useTranslation } from "react-i18next";
import { AiFillDollarCircle } from "react-icons/ai";
import { BsBank, BsChatTextFill, BsRobot } from "react-icons/bs";
import {
  FaBalanceScale,
  FaBus,
  FaRoute,
  FaStar,
  FaTools,
} from "react-icons/fa";
import { GiCarWheel } from "react-icons/gi";
import { GrTransaction, GrTroubleshoot } from "react-icons/gr";
import { IoSettings } from "react-icons/io5";
import {
  RiDashboardFill,
  RiFileList3Line,
  RiInfoCardLine,
  RiParentFill,
  RiSecurePaymentFill,
} from "react-icons/ri";
import { SlCalender } from "react-icons/sl";
import { DriverIcon } from "../../assets/images/driver";
import {
  BusCharterIcon,
  SubscriptionBusIcon,
  VendorBusingSubscriptionIcon,
} from "../../assets/images/Icons";
import Sidebar from "../Sidebar";
import { SiSimpleanalytics, SiWebmoney } from "react-icons/si";
import { FiCreditCard } from "react-icons/fi";
import { MdOutlinePayments, MdPayments } from "react-icons/md";
import { TbCreditCardPay } from "react-icons/tb";

const VendorSideMenu = ({ setCollapsedFromSidebar, isCollapsed }) => {
  const { t } = useTranslation();

  const menus = [
    {
      type: "link",
      icon: <BsRobot />,
      text: t("ask_ai"),
      to: "/ask-ai",
    },

    {
      type: "link",
      icon: <RiDashboardFill />,
      text: t("dashboard"),
      to: "/dashboard",
    },

    {
      type: "link",
      icon: <FaRoute />,
      text: t("tracking"),
      to: "/tracking",
    },
    {
      type: "dropdown",
      text: `${t("parents")} ${t("management")}`,
      icon: <RiParentFill />,
      children: [
        {
          type: "link",
          text: t("parents"),
          icon: <RiParentFill />,
          to: "/parents",
        },
        {
          type: "link",
          text: `${t("all")} ${t("students")}`,
          icon: <RiParentFill />,
          to: "/students",
        },
      ],
    },
    // Drivers
    {
      type: "link",
      icon: <DriverIcon />,
      text: t("drivers"),
      to: "/drivers",
    },
    // Vehicles Management
    {
      type: "dropdown",
      icon: <FaTools />,
      text: `${t("vehicles")} ${t("management")}`,
      children: [
        {
          type: "link",
          icon: <FaBus />,
          text: t("vehicles"),
          to: "/vehicles",
        },
        {
          type: "link",
          icon: <FaRoute />,
          text: `${t("route")} ${t("and")} ${t("schedule")}`,
          to: "/route-and-schedule",
        },
        {
          type: "link",
          icon: <GiCarWheel />,
          text: `${t("maintenance")} ${t("and")} ${t("inspection")}`,
          to: "/maintenance-and-inspection",
        },
        {
          type: "link",
          icon: <FaBalanceScale />,
          text: `${t("regulatory")} ${t("compliance")}`,
          to: "/regulatory-compliance",
        },
      ],
    },

    // Reservations + Vendor Subscriptions
    {
      type: "dropdown",
      icon: <SlCalender />,
      text: `${t("reservations")} & ${t("subscriptions")}`,
      children: [
        {
          type: "link",
          icon: <BusCharterIcon />,
          text: `${t("bus")} ${t("charter")} ${t("reservations")}`,
          to: "/bus-charter-reservations",
        },
        {
          type: "link",
          icon: <SubscriptionBusIcon />,
          text: `${t("busing")} ${t("subscriptions")}`,
          to: "/busing-subscriptions",
        },
        {
          type: "link",
          icon: <VendorBusingSubscriptionIcon />,
          text: `${t("vendor")} ${t("busing")} ${t("subscriptions")}`,
          to: "/vendor-busing-subscriptions",
        },
      ],
    },
    {
      type: "dropdown",
      text: `${t("payments")}`,
      icon: <GrTransaction />,
      children: [
        {
          type: "link",
          text: `${t("make")} ${t("payment")}`,
          icon: <FiCreditCard />,
          to: "/make-payment",
        },
        {
          type: "link",
          text: `${t("receive")} ${t("payment")}`,
          icon: <MdOutlinePayments />,
          to: "/receive-payment",
        },
      ],
    },

    {
      type: "link",
      icon: <BsBank />,
      text: `${t("subscription")} ${t("plans")}`,
      to: "/subscription-plans",
    },
    {
      type: "dropdown",
      icon: <GrTransaction />,
      text: `${t("payments")} ${t("history")}`,
      children: [
        {
          type: "link",
          icon: <SiWebmoney />,
          text: `${t("subscription")} ${t("history")}`,
          to: "/payment-history",
        },
        {
          type: "link",
          icon: <MdPayments />,
          text: `${t("parent")} ${t("payments")}`,
          to: "/parent-payments-received",
        },
        {
          type: "link",
          icon: <TbCreditCardPay />,
          text: `${t("manual")} ${t("payments")} ${t("history")}`,
          to: "/manual-payment-history",
        },
        {
          type: "link",
          text: `${t("receive")} ${t("payments")} ${t("history")}`,
          icon: <MdOutlinePayments />,
          to: "/receive-payment-history",
        },
      ],
    },

    {
      type: "link",
      icon: <SiSimpleanalytics />,
      text: `${t("reporting")} ${t("and")} ${t("analytics")}`,
      to: "/reporting-and-analytics",
    },

    // System Configuration
    {
      type: "dropdown",
      icon: <RiInfoCardLine />,
      text: `${t("system")} ${t("configuration")}`,
      children: [
        {
          type: "link",
          icon: <AiFillDollarCircle />,
          text: `${t("manage")} ${t("bus")} ${t("fee")}`,
          to: "/bus-fee",
        },
      ],
    },

    {
      type: "link",
      icon: <FaStar />,
      text: `${t("ratings")} ${t("and")} ${t("reviews")}`,
      to: "/ratings-and-reviews",
    },

    {
      type: "link",
      icon: <BsChatTextFill />,
      text: `${t("user")} ${t("communication")}`,
      to: "/user-communication",
    },

    {
      type: "link",
      icon: <GrTroubleshoot />,
      text: `${t("support")} ${t("and")} ${t("troubleshooting")}`,
      to: "/support",
    },
    {
      type: "link",
      icon: <IoSettings />,
      text: t("settings"),
      to: "/settings",
    },
  ];

  return (
    <Sidebar
      menu={menus}
      setCollapsedFromSidebar={setCollapsedFromSidebar}
      isCollapsed={isCollapsed}
      title="Vendor"
    />
  );
};

export default VendorSideMenu;
